import React from 'react';

function LoadingIcon() {
    return (<i className="fa fa-spinner fa-spin" />);
}

export default LoadingIcon;
